import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { formValueSelector, reduxForm } from 'redux-form';
import ValidationService from '../../lib/validation';
import { balanceSelector } from '../../modules/Customer/selectors';
import { isLoadingSelector } from '../../modules/LoadingStatus';
import { fetchVoucher } from '../../modules/VoucherAddMoney/actions';
import AddMoneyWithVoucher from './AddMoneyWithVoucher';

const validate = ({ voucherCode }) => ({
  voucherCode: ValidationService.validateVoucherCode(voucherCode),
});

const mapStateToProps = state => ({
  balance: balanceSelector(state),
  code: formValueSelector('voucherCode')(state, 'voucherCode'),
  isFetchingVoucher: isLoadingSelector(state, 'fetchVoucher'),
  isRedeemingVoucher: isLoadingSelector(state, 'redeemVoucher'),
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => {
    fetchVoucher(values.code)(dispatch);
  },
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'voucherCode',
    validate,
  })
);

export default enhance(AddMoneyWithVoucher);
